import dynamic from 'next/dynamic'
import Image from 'next/image'
import React, { useEffect } from 'react'

import useElementSize from '../../../hooks/useElementSize'
import useSizes from '../../../hooks/useSizes'
import useWindowDimensions from '../../../hooks/useWIndowDimentions'
import { getReadingTime } from '../../../utils/stringUtils'
import { BlogPostConfig, GhostPost } from '../../../utils/types'
import styles from './GuideHeader.module.scss'
import GuideHeaderText from './GuideHeaderText'
import Arrow from './arrow.svg'

const SongIdeasTool = dynamic(() => import('../SongIdeasTool/SongIdeasTool'))
const SongStructureTool = dynamic(() => import('../SongStructureTool/SongStructureTool'))

const STRINGS = {
  published: 'Published',
  comments: 'Comments',
}

type Props = {
  post: GhostPost
  published: string
  setHeight: (a: number) => void
  postConfig: BlogPostConfig
}

const GuideHeader: React.FC<Props> = ({ post, published, setHeight, postConfig }) => {
  const { head_config } = post
  const [setRef, , { height }] = useElementSize()
  const { width: windowWidth } = useWindowDimensions()
  useEffect(() => {
    setHeight(height)
  }, [height])
  const { isTablet } = useSizes()
  if (!head_config) {
    return null
  }
  const elementSSG = postConfig.isSSG
  const elementSIG = postConfig.isSIG
  const guideWithTool = elementSIG || elementSSG
  const renderToolBg = () => {
    const imgWidth = isTablet ? (windowWidth || 0) * 0.9 : 950
    const imgRatio = 430 / 950
    return (
      <div className={styles.toolBg}>
        <Image alt='tool-bg' src='/static/images/guide/tool-bg.png' width={imgWidth} height={imgRatio * imgWidth} />
      </div>
    )
  }
  return (
    <div className={styles.wrapper} data-tool={guideWithTool} ref={setRef}>
      <div className={styles.container}>
        <div className={styles.firstViewContainer} data-tool={guideWithTool}>
          {guideWithTool ? null : (
            <div className={styles.image}>
              <Image alt={post.title || ''} layout='fill' objectFit='contain' src={post.feature_image || ''} />
            </div>
          )}
          <div className={styles.infoLine}>
            <div>
              {STRINGS.published}: {published}
            </div>
            <div className={styles.divider} />
            <div>{getReadingTime(post.html as string)} min read</div>
          </div>
          <h1 className={styles.title}>{post.title}</h1>
          {post.excerpt && guideWithTool && <p className={styles.excerpt}>{post.excerpt}</p>}
          {guideWithTool ? (
            <div className={styles.toolContainer}>
              <Arrow className={styles.toolArrow} />
              {renderToolBg()}
              {elementSIG ? <SongIdeasTool /> : null}
              {elementSSG ? <SongStructureTool /> : null}
            </div>
          ) : null}
        </div>
        <div className={styles.textWrapper}>
          <GuideHeaderText post={post} postConfig={postConfig} />
        </div>
      </div>
    </div>
  )
}

export default GuideHeader
